import { styled, Button as TamaguiButton } from 'tamagui';

export type Variant =
  | 'primary'
  | 'destructive'
  | 'outlined'
  | 'outlined-destructive'
  | 'ghost'
  | 'ghostBrand';

/**
 * Generic Button component built with Tamagui's styled() API.
 * Follows project conventions: uses design tokens for colors, spacing, radius.
 * Supports variants, states (hover/press/focus via Tamagui), icon, disabled, loading.
 * Designed for reuse in a shared UI package.
 */
export const StyledButton = styled(TamaguiButton, {
  // Base props shared across all variants
  size: '$3',
  paddingHorizontal: '$true',
  borderRadius: '$0',
  fontWeight: '600',
  fontFamily: '$bold',
  fontSize: '$3',
  borderWidth: 1,

  // Variant styles
  variants: {
    variant: {
      primary: {
        backgroundColor: '$secondary',
        color: '$background',
        borderColor: '$secondary',
        pressStyle: { backgroundColor: '$secondary75' },
        hoverStyle: { backgroundColor: '$secondary75' },
        focusStyle: { borderColor: '$secondary', borderWidth: 2 },
      },
      destructive: {
        backgroundColor: '$errorFont',
        color: '$background',
        borderColor: '$errorFont',
        pressStyle: { backgroundColor: '$error' },
        hoverStyle: { backgroundColor: '$error' },
        focusStyle: { borderColor: '$errorFont', borderWidth: 2 },
      },
      outlined: {
        backgroundColor: 'transparent',
        color: '$color',
        borderColor: '$color',
        pressStyle: { backgroundColor: '$secondary25' },
        hoverStyle: { backgroundColor: '$secondary25' },
        focusStyle: { borderColor: '$color', borderWidth: 2 },
      },
      'outlined-destructive': {
        backgroundColor: 'transparent',
        color: '$errorFont',
        borderColor: '$errorFont',
        pressStyle: { backgroundColor: 'transparent' },
        hoverStyle: { backgroundColor: 'transparent' },
        focusStyle: { borderColor: '$errorFont', borderWidth: 2 },
      },
      ghost: {
        backgroundColor: 'transparent',
        color: '$secondary',
        borderColor: 'transparent',
        borderWidth: 0,
        pressStyle: { backgroundColor: '$transparent' },
        hoverStyle: { backgroundColor: '$transparent' },
        focusStyle: { borderColor: '$transparent', borderWidth: 0 },
      },
      ghostBrand: {
        backgroundColor: 'transparent',
        color: '$brand',
        borderColor: 'transparent',
        borderWidth: 0,
        pressStyle: { backgroundColor: '$transparent' },
        hoverStyle: { backgroundColor: '$transparent' },
      },
    },
    // Disabled state: reduces opacity across all variants
    disabled: {
      true: {
        opacity: 0.5,
      },
    },
  },

  defaultVariants: {
    variant: 'primary',
  },
});
